// Browser entry: runs before hydration.
import { StartClient } from "@tanstack/react-start/client";
import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { armDeferredHydration } from "src/components/common/DeferredHydration/DeferredHydrationGates";
import { installBrowserLogCapture } from "src/lib/BrowserLogs";
import { installStylesheetRecovery } from "src/lib/StaleBuild";

// Keep recent console output from the start, so feedback can include it.
installBrowserLogCapture();

// A stylesheet that failed to load (HTML and deployed build out of step) reloads the page.
if (!import.meta.env.DEV) installStylesheetRecovery();

// iOS Safari only applies :active styles once a touchstart listener exists.
window.addEventListener("touchstart", () => {});

// Dev: hot updates link a server component's stylesheet again without unlinking the old copy.
if (import.meta.env.DEV) {
  void import("src/lib/DevStylesheets").then(({ installDevStylesheetCleanup }) =>
    installDevStylesheetCleanup(),
  );
}

// Content marked for deferred hydration keeps its server HTML until it is needed.
armDeferredHydration();

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <StartClient />
    </StrictMode>,
  );
});
